/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.filter('SearchEventFilter', function () {
    return function (item, model) {
        var ret = []
        if (model == undefined)
        {
            ret = item
        } else
        {
            searchWord = model.toLowerCase();
            console.log(item)
            item.forEach(function (el) {
                console.log(el)
                var eventname = el.Veranstaltungsname.toLowerCase();
                var index = eventname.indexOf(searchWord)
                
                if (index > -1)
                {
                    ret.push(el)
                }

            })
        }
        return ret;
    };

});